import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Acompanhamento from './pages/Acompanhamento';
import StatusPedidos from './pages/StatusPedidos';
import Principal from './pages/Principal';
import Home from './pages/Home';
import Lista from './pages/Lista';
import Tracking from './pages/Tracking';

function Routes() {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/order/:orderId" exact component={Tracking} />
                <Route path="/tracking/:orderId" component={Principal} />
                <Route path="/acompanhamento" component={Acompanhamento} />
                <Route path="/statuspedidos" component={StatusPedidos} />
                <Route path="/meus-pedidos" component={Lista} />
                <Route path="/pedido/:orderId" component={Tracking} />
                <Route path="/" component={Home} />
            </Switch>
        </BrowserRouter>
    );
}

export default Routes;